import { useEffect, useState } from "react";
import { api, parseApiError } from "../lib/api";
import AdminLogin from "./AdminLogin";
import AdminReservations from "./AdminReservations";
import AdminCalendar from "./AdminCalendar";
import "./admin.css";

export default function AdminApp() {
  const [authState, setAuthState] = useState("checking"); // checking | out | in
  const [authErr, setAuthErr] = useState(null);
  const [tab, setTab] = useState("reservations");

  // Probe /api/admin/me to figure out whether the cookie is valid.
  const probe = async () => {
    setAuthState("checking");
    try {
      await api.get("/admin/me");
      setAuthState("in");
    } catch (e) {
      if (e?.response?.status === 401) setAuthState("out");
      else { setAuthState("out"); setAuthErr(parseApiError(e)); }
    }
  };
  useEffect(() => { probe(); }, []);

  const onLoggedIn = () => { setAuthErr(null); setAuthState("in"); };

  const logout = async () => {
    try { await api.post("/admin/logout"); } catch {/* ignore */}
    setAuthState("out");
  };

  if (authState === "checking") {
    return (
      <div className="admin-shell" data-testid="admin-checking">
        <div className="admin-loading">Checking session…</div>
      </div>
    );
  }
  if (authState === "out") {
    return <AdminLogin onSuccess={onLoggedIn} initialError={authErr} />;
  }

  return (
    <div className="admin-shell" data-testid="admin-shell">
      <header className="admin-header">
        <div className="admin-header__brand">
          <div className="admin-header__mark">Aquarius · Admin</div>
          <div className="admin-header__sub">Ocho Rios · Operator dashboard</div>
        </div>
        <nav className="admin-tabs" role="tablist">
          <button
            data-testid="admin-tab-reservations"
            role="tab"
            aria-selected={tab === "reservations"}
            className={`admin-tab ${tab === "reservations" ? "is-active" : ""}`}
            onClick={() => setTab("reservations")}
          >Reservations</button>
          <button
            data-testid="admin-tab-calendar"
            role="tab"
            aria-selected={tab === "calendar"}
            className={`admin-tab ${tab === "calendar" ? "is-active" : ""}`}
            onClick={() => setTab("calendar")}
          >Calendar</button>
        </nav>
        <button data-testid="admin-logout" onClick={logout} className="admin-logout">Logout</button>
      </header>

      <main className="admin-main">
        {tab === "reservations" && <AdminReservations />}
        {tab === "calendar" && <AdminCalendar />}
      </main>
    </div>
  );
}
